"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var theme_1 = __importDefault(require("../../../styles/theme"));
var makeStyles_1 = __importDefault(require("../../../util/makeStyles"));
exports.default = (0, makeStyles_1.default)(function () {
    return (0, styles_1.createStyles)({
        labelRoot: {
            marginLeft: 0,
        },
        disabledRoot: {
            opacity: '0.5',
        },
        radio: {
            color: theme_1.default.colors.dark,
            '&:hover': {
                backgroundColor: 'transparent !important',
            },
        },
        endLabelPadding: {
            padding: '0px 12px 0px 0px',
        },
        startLabelPadding: {
            padding: '0px 0px 0px 12px',
        },
        topLabelPadding: {
            padding: '12px 0px 0px 0px',
        },
        bottomLabelPadding: {
            padding: '0px 0px 12px 0px',
        },
        withoutLabelPadding: {
            padding: 0,
        },
        radioIcon: {
            '& path': {
                stroke: theme_1.default.colors.dark,
                strokeWidth: '2px',
            },
        },
        hoverDefault: {
            '.hoverable:hover & $radioIcon': {
                '& path': {
                    fill: "".concat(theme_1.default.colors.primaryLight, " !important"),
                    stroke: theme_1.default.colors.primary,
                },
            },
        },
        hasError: {
            '& $radioIcon path': {
                stroke: theme_1.default.colors.error,
            },
            '& .radioIconChecked path': {
                fill: theme_1.default.colors.error,
            },
            '.hoverable:hover & $radioIcon path': {
                fill: "".concat(theme_1.default.colors.errorLight, " !important"),
                stroke: theme_1.default.colors.error,
            },
        },
        disabled: {
            opacity: 0.75,
            '.hoverable:hover & $radioIcon': {
                '& path': {
                    stroke: theme_1.default.colors.dark,
                    fill: "".concat(theme_1.default.colors.globalBackgroundDark, " !important"),
                },
            },
        },
        withoutLabelMargins: {
            marginLeft: 0,
            marginRight: 0,
        },
    });
});
